import * as React from 'react';

import { SearchInput as DesignSearchInput } from '@acceligentllc/storybook';

export * from './useSearchInputState';

type Props = React.ComponentProps<typeof DesignSearchInput>;

const SearchInput: React.FC<Props> = (props) => {
	const { value, onChange } = props;

	return (
		<DesignSearchInput
			{...props}
			name="search"
			onChange={onChange}
			placeholder="Search"
			value={value}
		/>
	);
};

export default React.memo(SearchInput);
